import { REACT_APP_HOST_NAME } from '../../config';
import { CleosStatusI, MonitoringDrone } from '../../model/realtimeMonitoringInterface';
import { planningGridAsyncMod,
  planningInnerAsyncMod, planningMaxMinAsyncMod } from '../../services/mapToolsAPI';
import { fetchAllDetections, fetchCloseVideo,
  fetchHomePosition } from '../../services/monitoringAPI';
import { LatLng } from '../../utility/gridJob';
import { post } from '../../utility/http';
import { DEGREE_SYSTEM, METER_SYSTEM, transformDegreeToMercator } from '../../utility/proj_util';

const internalFetchHomePositionMain = async (uavId: string,
  droneIdentifier: string, terrainFollow: boolean) =>
{
  const homePosition: number = terrainFollow?
    await fetchHomePosition(uavId, localStorage.getItem('context'), droneIdentifier):0;
  ////console.log(homePosition);
  return homePosition;
};

export const fetchHomePositionMain    = async (jobSelected: any, uavId: string,
  droneIdentifier: string) =>
{
  ////console.log(jobSelected);
  const terrainFollow: boolean = jobSelected?.props.dataGrid.terrainFollow??false;

  return await internalFetchHomePositionMain(uavId, droneIdentifier, terrainFollow);
};

export const calculateBuffer = async (bufferUpdate: any,
  selected: any, droneDetail: any,
  resumeFlight: boolean, lastPosition: number | undefined,
) => {

  /*const homePosition = await fetchHomePositionMain(selected, droneDetail?.uavId,
    droneDetail?.job?.props?.droneIdentifier
  );*/
  const bufferH = (bufferUpdate?.distance ??
    (selected?.data?.dataFly?.bufferH ?? selected?.props?.dataGrid?.bufferH)) ?? 15;
  const bufferV = (bufferUpdate?.distanceV ??
    (selected?.data?.dataFly?.bufferV ?? selected?.props?.dataGrid?.bufferV)) ?? 15;

  let alt = 0;
  //let elevation = 0;
  let count = 0;
  const points: any[] = (selected?.data?.dataFly?.points??selected?.data?.dataFly)??[];
  //console.log(points);
  for (const point of points) {
    if ((resumeFlight === true) &&
      ((((lastPosition ?? 0) > 0) && (count >= (lastPosition ?? 0))) ||
       ((lastPosition ?? -1) <= 0)) || (resumeFlight === false)) {
      alt = Math.max(point?.alt ??point?.altitude ?? 0, alt);
    }

    count++;
  }

  const quotaMax = selected?.data?.dataFly?.quotaMax ?? selected?.props?.dataGrid?.quotaMax;
  //const height = alt + elevation + bufferV - (homePosition??0);
  const height =  alt;

  return {
    distance: bufferH,
    distanceV: bufferV, height: height, quotaMax
  };

};


export const getCommandGoToElevAsync = async (drone: MonitoringDrone,
  selected: any, droneDetail: any,
  guided: LatLng , terrain: boolean, goToParams: any,
  quotaMax: number | undefined, loadMission: boolean) => {

  const coords: LatLng[] = [{
    longitude: drone?.props?.lng??drone?.lng,
    latitude: drone?.props?.lat??drone?.lat
  }, guided,];

  //console.log(coords);
  quotaMax = quotaMax?? 120;
  let maxalt = 0;
  let altMSL_stop = 0;
  let terrainFollow : boolean = selected?.props.dataGrid.terrainFollow ?? false;

  if (terrain === true ) {
    terrainFollow = true;

    if (quotaMax > 0){
      const response: any = await
      planningMaxMinAsyncMod(coords, goToParams?.demName, DEGREE_SYSTEM);

      const locStart = response?.data?.quotas.length>0?response?.data?.quotas[0]:undefined;
      const locStop = response?.data?.quotas.length>1?response?.data?.quotas[1]:undefined;
      const altMSL_start = locStart?.elevation??0;
      altMSL_stop = locStop?.elevation??0;
      maxalt = response?.data?.max;
      console.log('goToParams and maxalt');
      console.log(goToParams);
      console.log(maxalt);

      ////console.log(quotaMax);
      maxalt += (goToParams?.heightObstacle ?? 0);
      ////console.log(altMSL_start);
      //console.log(altMSL_stop);
      console.log(maxalt);
      if ((Math.max(altMSL_start, altMSL_stop) +  goToParams?.heightGround) > maxalt) {
        maxalt = Math.max(altMSL_start, altMSL_stop) + goToParams?.heightGround;
      }

      console.log(maxalt);

      const maxElevation = maxalt - response?.data?.min;

      if (maxElevation > (quotaMax ?? 0)) {
        return {
          error: 'QuotaGroundError',
          params: { 'meters': maxElevation }
        };
      }
    }
  }
  else {
    if ((quotaMax ?? 0)>0){
      if ((goToParams?.heightObstacle ?? 0) > (quotaMax ?? 0)) {
        return {
          error: 'QuotaGroundError',
          params: { 'meters': quotaMax ?? 0 }
        };

      }
    }

  }


  const pointM = transformDegreeToMercator([coords[1].longitude, coords[1].latitude]);
  const responseGeometry: any = await planningInnerAsyncMod(
    selected?.taskId == null ? '' : selected.taskId,
    {
      'coordinates': [
        pointM[0], pointM[1]
      ],
      'crs': {
        'properties': {
          'name': METER_SYSTEM
        },
        'type': 'name'
      },
      'type': 'Point'
    }

  );
  //console.log(responseGeometry);

  const intoArea = responseGeometry?.data ?? false;
  if (intoArea == false) {
    return {
      error: 'PointNotInsideArea',
      params: {}
    };
  }
  else {
    console.log(selected);
    const homePosition: number = await internalFetchHomePositionMain(droneDetail?.uavId,
      droneDetail?.job?.props?.droneIdentifier, terrainFollow
    );
    let alt = parseFloat((goToParams?.heightGround ?? 0).toFixed(1));
    console.log(`heightGround:${goToParams?.heightGround} - alt:${alt}
      - terrainFollow:${terrainFollow} `);


    if (terrainFollow===true) {
      const response: any = await planningGridAsyncMod([coords[1]], goToParams?.demName, true, -1,
        DEGREE_SYSTEM, false, undefined);
      if (response?.error) {
        return {
          error: response?.error?.data?.error,
          params: {}
        };

      }
      else {

        const gridCoordinates = response?.data?.quotas;
        //console.log(gridCoordinates);
        if (gridCoordinates && gridCoordinates.length > 0 && gridCoordinates[0].elevation != null) {

          //console.log(gridCoordinates[0].elevation);
          //console.log(parseFloat(gridCoordinates[0].elevation) );
          alt += (parseFloat(gridCoordinates[0].elevation) - homePosition);
          console.log(`elevation:${gridCoordinates[0].elevation}
            homePosition:${homePosition} - alt:${alt} `);

        }
      }
    }

    const command: any = {
      cmd: terrain ? 'goto_step_loc' : 'goto_loc',
      uav_id: droneDetail?.uavId,
      lat: guided.latitude,
      lon: guided.longitude,
      alt: alt
    };
    if (terrain === true) {
      command.maxalt = maxalt - homePosition;
    }

    if (loadMission === true){
      command.finalQuota = altMSL_stop + goToParams?.heightGround - homePosition;
    }

    return command;

  }

};

/*export const handlePanTilt = async () => {
  try {
    const response: any = await get('/asset-management/actions/byName/gimbal_dir',
      true,
      {},
      false,
      true);
    return { opened: true, action: { ...response?.data,
      params: {} }, actionList: [response?.data] };

  }
  catch (ex) {
    return undefined;
  }
};*/

export const sendAction = async (data: any ) => {
  try {
    ////console.log(data);
    const action: any = { id: data?.action?.id, params: {} };

    data?.attributes?.forEach((attr: any) => {
      action.params[attr.id] = attr.value;
    });

    const toDroneAction: any = await post('/asset-management/actions/toDroneAction',
      true, {}, action, false, true);
    //console.log(toDroneAction);
    if (toDroneAction?.data?.data && toDroneAction?.data?.data?.length > 0) {
      const action = toDroneAction?.data?.data[0]?.param;
      //console.log(action);
      return {action: action};
    }
  }
  catch (ex) {
    //console.log(ex);
  }
  return {error: 'CommandError'};
};

export const closeVideo = async (runId: string, uavId: string) => {

  const ctxLabel = JSON.parse(localStorage.getItem('contextData') ?? '')?.label;
  const tot_active_detections: CleosStatusI[] | undefined =
    await fetchAllDetections(
      { ctx_id: ctxLabel });

  if (tot_active_detections) {
    const dects: CleosStatusI[] = tot_active_detections
      .filter((it: any) => it.run_id === runId
        && it.uav_id === uavId);
    for (const dect of dects) {
      console.log('chiamata per closeVideo');
      console.log(dect.detection_id);
      await fetchCloseVideo(
        uavId,
        ctxLabel ?? '',
        dect.detection_id,
        runId,
        REACT_APP_HOST_NAME
      );
    }
  }
};


export const isCommandWarning = (cmd: string) => {
  return (cmd === 'land'
    || cmd === 'takeoff'
    || cmd === 'start_mission');
};
